export enum HiddenDataType {
  Goals = 'goals',
  FxRates = 'fxRates',
  Budgets = 'budgets',
  LinkedAccounts = 'linkedAccounts',
  LinkedDebtors = 'linkedDebtors',
  EnvelopeMeta = 'EnvelopeMeta',
  UserSettings = 'UserSettings',
  TagOrder = 'tagOrder',
}
